import React, { useCallback, useEffect, useMemo, useState } from "react";
import LoaderPage from "../../../../../layouts/loader-page/loader-page";
import { Button, DataGrid } from "devextreme-react";
import { getPropsDataGrid } from "../../../../../utils/default-props";
import { Column, Editing, Item, Toolbar } from "devextreme-react/cjs/data-grid";
import { getDataGridCustomToolbarCaption } from "../../../../../components/default-components/data-grid-custom-toolbar";
import { usePublicEvents } from "../../../../../contexts/public-events";
import { useNavigate } from "react-router-dom";
import CustomStore from "devextreme/data/custom_store";
import { useDataSource } from "../../../../../contexts/dataSource";

export function CheckListTemplateList() {

    const [formData, setFormData] = useState(
        [
            {
                "name": "CheckListTemplate",
                "id": "8c1f3e80-d8a1-4ea2-92d2-4b319e72a2b2",
                "key": "1"
            }, {
                "name": "CheckListTemplate",
                "id": "fd78991f-29dc-4590-88ad-0e3e0aeb57b9",
                "key": "2"
            }
        ]

    )
    const { setPublicAddEvent } = usePublicEvents()
    const navigate = useNavigate();
    const { dataSourceHR } = useDataSource()
    const [id, setId] = useState(null)

    const dataSource = useMemo(() => dataSourceHR({
        loadUrl: "/api/EmployeeCheckListTemplate",
        insertUrl: "/api/EmployeeCheckListTemplate/FormData",
    }), [dataSourceHR])

    const onCellDblClick = useCallback((e) => {
        navigate(`/checklist-template/card/${id}`)
    }, [id])

    // const store = new CustomStore({
    //     key: 'id',
    //     async load(loadOptions) {
    //         return {
    //             data: formData,
    //             totalCount: 2,
    //             summary: 0,
    //             groupCount: 1,
    //         };
    //     },
    // });

    const onFocusedRowChanged = (e) => {
        setId(e.component.option('focusedRowKey'));
    }

    useEffect(() => {

        if (setPublicAddEvent)
            setPublicAddEvent(() => {
                return () => { navigate('/checklist-template/card') }
            })

        return () => {
            if (setPublicAddEvent)
                setPublicAddEvent(undefined)
        }

    }, [setPublicAddEvent, navigate])

useEffect(()=>{console.log("id",id)},[id]);
    return (
        <LoaderPage
            loading={false}
        >
            <DataGrid
                {...getPropsDataGrid}
                dataSource={dataSource}
                onCellDblClick={onCellDblClick}
                onFocusedRowChanged={onFocusedRowChanged}
            >
                <Editing
                    allowDeleting={true}
                />
                <Toolbar>
                    {getDataGridCustomToolbarCaption("Check List Şablonları")}
                </Toolbar>
                <Column dataField="id" visible={false} />
                <Column dataField="name" caption="Şablon Tanımı">
                </Column>

            </DataGrid>
        </LoaderPage>
    )
}

